// extracted by mini-css-extract-plugin
export default {"root":"Question_root__zzQ94"};